import {auth, post, url} from "../../../app/services/Backend/HttpRequest"

export default {

  fetchPricesCompare({rootState, commit}, payload){

    const input = {
      url: url('auth/statistics/price'),
      payload,
      headers: auth(rootState)
    }

    return post(input).then(response => commit('fillPricesCompare', response.data))
  },

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/statistics/actions.js